// import React from 'react'
// import Navbar from './Navbar'
// import axios from 'axios'
// import { useNavigate } from 'react-router-dom'
// import { Card } from 'react-bootstrap'
// import GradCap from '../Assets/Assests/image (3).png'
// import GameIcon from '../Assets/Assests/image (2).png'
// import bulbIcon from '../Assets/Assests/image (1).png'
// import Institution from '../Assets/Assests/image.png'
// import AmazonLogo from '../Assets/Assests/image (7).png'
// import NasscomLogo from '../Assets/Assests/image (6).png'
// import MicrosoftLogo from '../Assets/Assests/image (5).png'
// import IBMLogo from '../Assets/Assests/image (4).png'
// import { useState } from 'react'
// import { Spinner } from 'react-bootstrap'

// const CategoryCard = ({ icon, title, category }) => {
//   const navigate = useNavigate()
//   const [loading, setLoading] = useState(false) // State to manage loader

//   const handleCardClick = async () => {
//     const token = localStorage.getItem('access')
//     if (!token) {
//       console.error('No access token found. Please log in.')
//       return
//     }

//     setLoading(true) // Start loading

//     try {
//       const response = await axios.post(
//         'https://aimuseumbackend.teslabird.com/auth/sections-by-category/',
//         { category },
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )

//       // console.log('API Response:', response.data)
//       navigate(`/${category}`, { state: { sections: response.data } })
//     } catch (error) {
//       console.error(
//         'Error fetching category data:',
//         error.response?.data || error.message
//       )
//     } finally {
//       setLoading(false) // Stop loading after API call
//     }
//   }

//   return (
//     <div className='col-md-3 col-sm-6 mb-4 d-flex align-items-stretch'>
//       <div
//         className='text-center p-4 shadow-sm flex-fill'
//         style={{
//           backgroundColor: '#B02013',
//           borderRadius: '12px',
//           color: 'white',
//           border: 'none',
//           transition: 'transform 0.2s ease-in-out',
//           height: '100%',
//           cursor: 'pointer',
//           position: 'relative', // Ensures loader is centered
//         }}
//         onClick={handleCardClick}
//         onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
//         onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//       >
//         {loading ? (
//           // Show Spinner while loading
//           <div
//             className='d-flex justify-content-center align-items-center'
//             style={{ height: '100%' }}
//           >
//             <Spinner animation='border' variant='light' />
//           </div>
//         ) : (
//           // Show Card content when not loading
//           <>
//             <div style={{ marginBottom: '15px' }}>
//               <img
//                 src={icon}
//                 alt={title}
//                 style={{ width: '70px', height: '70px' }}
//               />
//             </div>
//             <h5 className='mb-0' style={{ fontWeight: 'bold' }}>
//               {title}
//             </h5>
//           </>
//         )}
//       </div>
//     </div>
//   )
// }

// export default function Home() {
//   const categories = [
//     {
//       icon: GradCap,
//       title: 'Skill Development',
//       category: 'skill_development',
//     },
//     {
//       icon: GameIcon,
//       title: 'Mental & Physical Wellness',
//       category: 'mental_and_physical_wellness',
//     },
//     { icon: bulbIcon, title: 'Inspiration', category: 'inspiration' },
//     {
//       icon: Institution,
//       title: 'Institution',
//       category: 'institution_notifications',
//     },
//   ]

//   const partners = [
//     { logo: AmazonLogo, alt: 'Amazon' },
//     { logo: NasscomLogo, alt: 'NASSCOM' },
//     { logo: MicrosoftLogo, alt: 'Microsoft' },
//     { logo: IBMLogo, alt: 'IBM' },
//   ]

//   return (
//     <>
//       <Navbar />
//       <div className='container mt-4'>
//         <div className='row'>
//           {categories.map(({ icon, title, category }) => (
//             <CategoryCard
//               key={category}
//               icon={icon}
//               title={title}
//               category={category}
//             />
//           ))}
//         </div>

//         <div className='row mt-5 text-center'>
//           <h2 className='mb-4'>Partners</h2>
//           <div className='d-flex justify-content-center gap-4 flex-wrap'>
//             {partners.map(({ logo, alt }) => (
//               <img
//                 key={alt}
//                 src={logo}
//                 alt={alt}
//                 style={{
//                   height: '50px',
//                   objectFit: 'contain',
//                   marginBottom: '6px',
//                 }}
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// import React, { useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { Spinner } from 'react-bootstrap'
// import Navbar from './Navbar'
// import axios from 'axios'
// import GradCap from '../Assets/Assests/image (3).png'
// import GameIcon from '../Assets/Assests/image (2).png'
// import bulbIcon from '../Assets/Assests/image (1).png'
// import Institution from '../Assets/Assests/image.png'
// import AmazonLogo from '../Assets/Assests/image (7).png'
// import NasscomLogo from '../Assets/Assests/image (6).png'
// import MicrosoftLogo from '../Assets/Assests/image (5).png'
// import IBMLogo from '../Assets/Assests/image (4).png'
// import certificate from '../Assets/Assests/mdi_diploma.png'
// import HealthIcon from '../Assets/Assests/pajamas_doc-new.png'
// import TrainingIcon from '../Assets/Assests/fluent_form-new-20-filled.png'
// import ScholarshipIcon from '../Assets/Assests/fluent-mdl2_publish-course.png'
// import Startup from '../Assets/Assests/startup 1.png'
// import Concerts from '../Assets/Assests/concert 1.png'
// import Monuments from '../Assets/Assests/Monuments 1.png'
// import AiTool from '../Assets/Assests/AI Tool 1.png'
// import K21Skills from '../Assets/Assests/skill- 1.png'

// const CategoryCard = ({ icon, title, category, noApiCall }) => {
//   const navigate = useNavigate()
//   const [loading, setLoading] = useState(false)

//   const handleCardClick = async () => {
//     if (noApiCall) {
//       navigate(`/${category}`)
//       return
//     }

//     const token = localStorage.getItem('access')
//     if (!token) {
//       console.error('No access token found. Please log in.')
//       return
//     }

//     setLoading(true)

//     try {
//       const response = await axios.post(
//         'https://aimuseumbackend.teslabird.com/auth/sections-by-category/',
//         { category },
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )

//       console.log('API Response:', response.data)
//       navigate(`/${category}`, { state: { sections: response.data } })
//     } catch (error) {
//       console.error(
//         'Error fetching category data:',
//         error.response?.data || error.message
//       )
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <div className='col-12 col-sm-6 col-md-6 col-lg-3 mb-4 d-flex align-items-stretch'>
//       <div
//         className='text-center p-4 shadow-sm flex-fill h-100 w-100'
//         style={{
//           backgroundColor: '#B02013',
//           borderRadius: '12px',
//           color: 'white',
//           border: 'none',
//           transition: 'transform 0.2s ease-in-out',
//           cursor: 'pointer',
//           position: 'relative',
//         }}
//         onClick={handleCardClick}
//         onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
//         onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//       >
//         {loading ? (
//           <div className='d-flex justify-content-center align-items-center h-100'>
//             <Spinner animation='border' variant='light' />
//           </div>
//         ) : (
//           <>
//             {icon && (
//               <div className='mb-3'>
//                 <img
//                   src={icon}
//                   alt={title}
//                   style={{ width: '70px', height: '70px' }}
//                 />
//               </div>
//             )}
//             <h5 className='mb-0' style={{ fontWeight: 'bold' }}>
//               {title}
//             </h5>
//           </>
//         )}
//       </div>
//     </div>
//   )
// }

// export default function Home() {
//   const categories = [
//     {
//       icon: GradCap,
//       title: 'Skill Development',
//       category: 'skill_development',
//     },
//     {
//       icon: GameIcon,
//       title: 'Mental & Physical Wellness',
//       category: 'mental_and_physical_wellness',
//     },
//     { icon: bulbIcon, title: 'Inspiration', category: 'inspiration' },
//     {
//       icon: Institution,
//       title: 'Institution',
//       category: 'institution_notifications',
//     },
//     // { icon: TrainingIcon, title: 'Training', category: 'training' },
//   ]

//   const additionalCategories = [
//     // { icon: certificate, title: 'Internship', category: 'internship' },
//     // { icon: ScholarshipIcon, title: 'Scholarship', category: 'scholarship' },
//     // { icon: HealthIcon, title: 'Health Check-ups', category: 'health_checkup' },
//     // { icon: Startup, title: 'Startup', category: 'startup' },
//     // { icon: Concerts, title: 'Concerts', category: 'concerts' },
//     // { icon: Monuments, title: '250+ Monuments', category: 'monuments' },
//     // { icon: AiTool, title: 'AI Tools for Education', category: 'ai_tools' },
//     // { icon: K21Skills, title: 'K12 Skills Content', category: 'k21_skills' },
//   ]

//   const partners = [
//     { logo: AmazonLogo, alt: 'Amazon' },
//     { logo: NasscomLogo, alt: 'NASSCOM' },
//     { logo: MicrosoftLogo, alt: 'Microsoft' },
//     { logo: IBMLogo, alt: 'IBM' },
//   ]

//   return (
//     <>
//       <Navbar />
//       <div className='container mt-4'>
//         <div className='row row-cols-2 row-cols-md-2 g-4'>
//           {categories.map(({ icon, title, category }) => (
//             <CategoryCard
//               key={category}
//               icon={icon}
//               title={title}
//               category={category}
//             />
//           ))}
//         </div>

//         <div className='row row-cols-2 row-cols-md-2 g-4 mt-4'>
//           {additionalCategories.map(({ icon, title, category }) => (
//             <CategoryCard
//               key={category}
//               icon={icon}
//               title={title}
//               category={category}
//               noApiCall
//             />
//           ))}
//         </div>

//         <div className='row mt-5 text-center'>
//           <h2 className='mb-4'>Partners</h2>
//           <div className='d-flex justify-content-center gap-4 flex-wrap'>
//             {partners.map(({ logo, alt }) => (
//               <img
//                 key={alt}
//                 src={logo}
//                 alt={alt}
//                 style={{
//                   height: '50px',
//                   objectFit: 'contain',
//                   marginBottom: '6px',
//                 }}
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// import React, { useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { Spinner } from 'react-bootstrap'
// import axios from 'axios'
// import Yoga from '../Assets/Assests/Logos/yoga 1.png'
// import Health from '../Assets/Assests/Logos/health-assessment 1.png'
// import Podcast from '../Assets/Assests/Logos/mic 1.png'
// import Kit from '../Assets/Assests/Logos/first-aid-kit (1) 1.png'
// import AmazonLogo from '../Assets/Assests/Logos/Amazon-Logo 1.png'
// import NasscomLogo from '../Assets/Assests/Logos/blob 1.png'
// import MicrosoftLogo from '../Assets/Assests/Logos/microsoft-logo-microsoft-icon-transparent-free-png 1.png'
// import IBMLogo from '../Assets/Assests/Logos/IBM_logo.svg 1.png'
// import NSDC from '../Assets/Assests/Logos/NSDC-Photoroom 1 1.png'
// import IAO from '../Assets/Assests/Logos/IAO-Photoroom 1 1.png'
// import MSIL from '../Assets/Assests/Logos/Chit Funds _ Tours & Travels MSIL-Photoroom 1.png'
// import NIMHANS from '../Assets/Assests/Logos/National Institute of Mental Health and Neuro Sciences (NIMHANS) _ The  VALIDATE Network-Photoroom 1.png'
// import WHO from '../Assets/Assests/Logos/WHO_logo.png'
// import Navbar from './Navbar'

// const CategoryCard = ({ icon, title, category, noApiCall }) => {
//   const navigate = useNavigate()
//   const [loading, setLoading] = useState(false)

//   const handleCardClick = async () => {
//     if (noApiCall) {
//       navigate(`/${category}`)
//       return
//     }

//     const token = localStorage.getItem('access')
//     if (!token) {
//       console.error('No access token found. Please log in.')
//       return
//     }

//     setLoading(true)

//     try {
//       const response = await axios.get(
//         `https://aimuseumbackend.teslabird.com/membership/modules/?${category}`,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )

//       // Ensure response data is an array
//       const modules = Array.isArray(response.data) ? response.data : []

//       // Map module names safely
//       const sections = modules.map((item) => ({
//         id: item?.id ?? '',
//         module: item?.module ?? 'Unknown Module', // Fallback value
//         category: item?.category ?? '',
//         chapters: item?.chapter_count ?? '',
//       }))

//       navigate(`/${category}`, { state: { sections } })
//     } catch (error) {
//       console.error(
//         'Error fetching category data:',
//         error.response?.data || error.message
//       )
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <div className='col-12 col-sm-6 col-md-6 col-lg-3 mb-4 d-flex align-items-stretch'>
//       <div
//         className='text-center p-4 shadow-sm flex-fill h-100 w-100'
//         style={{
//           backgroundColor: '#002740',
//           borderRadius: '12px',
//           color: 'white',
//           border: 'none',
//           transition: 'transform 0.2s ease-in-out',
//           cursor: 'pointer',
//           position: 'relative',
//         }}
//         onClick={handleCardClick}
//         onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
//         onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//       >
//         {loading ? (
//           <div className='d-flex justify-content-center align-items-center h-100'>
//             <Spinner animation='border' variant='light' />
//           </div>
//         ) : (
//           <>
//             {icon && (
//               <div className='mb-3'>
//                 <img
//                   src={icon}
//                   alt={title}
//                   style={{ width: '70px', height: '70px' }}
//                 />
//               </div>
//             )}
//             <h5 className='mb-0' style={{ fontWeight: 'bold' }}>
//               {title}
//             </h5>
//           </>
//         )}
//       </div>
//     </div>
//   )
// }

// export default function Home() {
//   const categories = [
//     {
//       icon: Yoga,
//       title: 'Modules',
//       category: 'mental_and_physical_wellness',
//     },
//   ]

//   const additionalCategories = [
//     { icon: Health, title: 'Wellness Assessments', category: 'partners' },
//     { icon: Podcast, title: 'Experts Podcast', category: 'podcasts' },
//     { icon: Kit, title: 'Wellness Kit', category: 'wellness-kit' },
//   ]

//   const partners = [
//     { logo: AmazonLogo, alt: 'Amazon' },
//     { logo: NasscomLogo, alt: 'NASSCOM' },
//     { logo: MicrosoftLogo, alt: 'Microsoft' },
//     { logo: IBMLogo, alt: 'IBM' },
//     { logo: NSDC, alt: 'NSDC' },
//     { logo: IAO, alt: 'IAO' },
//     { logo: MSIL, alt: 'MSIL' },
//     { logo: NIMHANS, alt: 'NIMHANS' },
//     { logo: WHO, alt: 'WHO' },
//   ]

//   return (
//     <>
//       <Navbar />
//       <div className='container mt-4'>
//         {/* Main Categories in One Row */}
//         <div className='row row-cols-auto g-4 justify-content-start flex-nowrap overflow-auto'>
//           {categories.map(({ icon, title, category }) => (
//             <CategoryCard
//               key={category}
//               icon={icon}
//               title={title}
//               category={category}
//             />
//           ))}

//           {additionalCategories.map(({ icon, title, category }) => (
//             <CategoryCard
//               key={category}
//               icon={icon}
//               title={title}
//               category={category}
//               noApiCall
//             />
//           ))}
//         </div>

//         {/* Partners Section */}
//         <div className='row mt-5 text-center'>
//           <h2 className='mb-4'>Partners</h2>
//           <div
//             style={{
//               overflow: 'hidden',
//               whiteSpace: 'nowrap',
//               width: '100%',
//               position: 'relative',
//             }}
//           >
//             <div
//               style={{
//                 display: 'inline-block',
//                 whiteSpace: 'nowrap',
//                 animation: 'scroll-left 20s linear infinite',
//               }}
//             >
//               {partners.concat(partners).map(({ logo, alt }, index) => (
//                 <img
//                   key={index}
//                   src={logo}
//                   alt={alt}
//                   style={{
//                     height: '50px',
//                     margin: '0 30px',
//                     objectFit: 'contain',
//                     verticalAlign: 'middle',
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//         <style>
//           {`
//     @keyframes scroll-left {
//       0% {
//         transform: translateX(0%);
//       }
//       100% {
//         transform: translateX(-50%);
//       }
//     }
//   `}
//         </style>
//       </div>
//     </>
//   )
// }



import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import axios from 'axios'
import Yoga from '../Assets/Assests/Logos/yoga 1.png'
import Health from '../Assets/Assests/Logos/health-assessment 1.png'
import Podcast from '../Assets/Assests/Logos/mic 1.png'
import Kit from '../Assets/Assests/Logos/first-aid-kit (1) 1.png'
import AmazonLogo from '../Assets/Assests/Logos/Amazon-Logo 1.png'
import NasscomLogo from '../Assets/Assests/Logos/blob 1.png'
import MicrosoftLogo from '../Assets/Assests/Logos/microsoft-logo-microsoft-icon-transparent-free-png 1.png'
import IBMLogo from '../Assets/Assests/Logos/IBM_logo.svg 1.png'
import NSDC from '../Assets/Assests/Logos/NSDC-Photoroom 1 1.png'
import IAO from '../Assets/Assests/Logos/IAO-Photoroom 1 1.png'
import MSIL from '../Assets/Assests/Logos/Chit Funds _ Tours & Travels MSIL-Photoroom 1.png'
import NIMHANS from '../Assets/Assests/Logos/National Institute of Mental Health and Neuro Sciences (NIMHANS) _ The  VALIDATE Network-Photoroom 1.png'
import WHO from '../Assets/Assests/Logos/WHO_logo.png'
import Navbar from './Navbar'

const CategoryCard = ({ icon, title, category, noApiCall }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleCardClick = async () => {
    if (noApiCall) {
      navigate(`/${category}`)
      return
    }

    const token = localStorage.getItem('access')
    if (!token) {
      console.error('No access token found. Please log in.')
      return
    }

    setLoading(true)

    try {
      const response = await axios.get(
        `https://aimuseumbackend.teslabird.com/membership/modules/?${category}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )

      // Ensure response data is an array
      const modules = Array.isArray(response.data) ? response.data : []

      // Map module names safely
      const sections = modules.map((item) => ({
        id: item?.id ?? '',
        module: item?.module ?? 'Unknown Module', // Fallback value
        category: item?.category ?? '',
        chapters: item?.chapter_count ?? '',
      }))

      navigate(`/${category}`, { state: { sections } })
    } catch (error) {
      console.error(
        'Error fetching category data:',
        error.response?.data || error.message
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    // Responsive column classes - 1 column on xs, 2 on sm, 2 on md, 4 on lg+
    <div className='col-12 col-sm-6 col-md-6 col-lg-3 mb-3 mb-md-4 d-flex align-items-stretch'>
      <div
        className='text-center p-3 p-md-4 shadow-sm flex-fill h-100 w-100'
        style={{
          backgroundColor: '#002740',
          borderRadius: '12px',
          color: 'white',
          border: 'none',
          transition: 'transform 0.2s ease-in-out',
          cursor: 'pointer',
          position: 'relative',
          minHeight: 'clamp(140px, 20vw, 180px)', // Responsive min height
        }}
        onClick={handleCardClick}
        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        {loading ? (
          <div className='d-flex justify-content-center align-items-center h-100'>
            <Spinner animation='border' variant='light' />
          </div>
        ) : (
          <>
            {icon && (
              <div className='mb-2 mb-md-3'>
                <img
                  src={icon || '/placeholder.svg'}
                  alt={title}
                  style={{
                    width: 'clamp(50px, 8vw, 70px)',
                    height: 'clamp(50px, 8vw, 70px)',
                    objectFit: 'contain',
                  }}
                />
              </div>
            )}
            <h5
              className='mb-0'
              style={{
                fontWeight: 'bold',
                fontSize: 'clamp(0.9rem, 2.5vw, 1.25rem)',
                lineHeight: '1.3',
              }}
            >
              {title}
            </h5>
          </>
        )}
      </div>
    </div>
  )
}

export default function Home() {
  const categories = [
    {
      icon: Yoga,
      title: 'Modules',
      category: 'mental_and_physical_wellness',
    },
  ]

  const additionalCategories = [
    { icon: Health, title: 'Wellness Assessments', category: 'partners' },
    { icon: Podcast, title: 'Experts Podcast', category: 'podcasts' },
    { icon: Kit, title: 'Wellness Kit', category: 'wellness-kit' },
  ]

  const partners = [
    { logo: AmazonLogo, alt: 'Amazon' },
    { logo: NasscomLogo, alt: 'NASSCOM' },
    { logo: MicrosoftLogo, alt: 'Microsoft' },
    { logo: IBMLogo, alt: 'IBM' },
    { logo: NSDC, alt: 'NSDC' },
    { logo: IAO, alt: 'IAO' },
    { logo: MSIL, alt: 'MSIL' },
    { logo: NIMHANS, alt: 'NIMHANS' },
    { logo: WHO, alt: 'WHO' },
  ]

  return (
    <>
      <Navbar />
      {/* Responsive container with padding */}
      <div className='container-fluid px-3 px-md-4 mt-3 mt-md-4'>
        {/* Main Categories - Responsive Grid */}
        <div className='row g-3 g-md-4 justify-content-center justify-content-lg-start'>
          {categories.map(({ icon, title, category }) => (
            <CategoryCard
              key={category}
              icon={icon}
              title={title}
              category={category}
            />
          ))}

          {additionalCategories.map(({ icon, title, category }) => (
            <CategoryCard
              key={category}
              icon={icon}
              title={title}
              category={category}
              noApiCall
            />
          ))}
        </div>

        {/* Partners Section - Responsive */}
        <div className='row mt-4 mt-md-5 text-center'>
          <div className='col-12'>
            <h2
              className='mb-3 mb-md-4'
              style={{ fontSize: 'clamp(1.5rem, 4vw, 2rem)' }}
            >
              Partners
            </h2>
            <div
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                width: '100%',
                position: 'relative',
              }}
            >
              <div
                style={{
                  display: 'inline-block',
                  whiteSpace: 'nowrap',
                  animation: 'scroll-left 20s linear infinite',
                }}
              >
                {partners.concat(partners).map(({ logo, alt }, index) => (
                  <img
                    key={index}
                    src={logo || '/placeholder.svg'}
                    alt={alt}
                    style={{
                      height: 'clamp(35px, 6vw, 50px)', // Responsive height
                      margin: 'clamp(10px, 3vw, 30px)', // Responsive margin
                      objectFit: 'contain',
                      verticalAlign: 'middle',
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Responsive CSS Animation */}
        <style>
          {`
            @keyframes scroll-left {
              0% {
                transform: translateX(0%);
              }
              100% {
                transform: translateX(-50%);
              }
            }

            /* Additional responsive utilities */
            @media (max-width: 576px) {
              .container-fluid {
                padding-left: 15px !important;
                padding-right: 15px !important;
              }
            }

            @media (max-width: 768px) {
              .row {
                margin-left: -8px !important;
                margin-right: -8px !important;
              }
              .row > * {
                padding-left: 8px !important;
                padding-right: 8px !important;
              }
            }
          `}
        </style>
      </div>
    </>
  )
}
